import { LocaleUpdatedAction } from 'state/actions/types/i18nActionsTypes';

export const localeUpdated = (locale: string): LocaleUpdatedAction => {
  return {
    type: 'LOCALE_UPDATED',
    payload: locale,
  };
};
